import baseService from './baseService';
import config from '../../config';

export default{
    getMe(params){
        return baseService.get(config.API_LOCATION + 'user',params)
    },
    login(params){
        return baseService.post(config.API_LOCATION + 'auth/authenticate',params)
    },
    logout(){
        return baseService.post(config.API_LOCATION + 'auth/logout',{})
    },
    register(params){
        return baseService.post(config.API_LOCATION + 'auth/register',params)
    },
    sentResetMail(params){
        return baseService.post(config.API_LOCATION + 'auth/reset-password',params)
    },
    resetPassword(params){
        return baseService.post(config.API_LOCATION + 'auth/reset/password',params)
    }
    


}

